import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { createActionCreator, createBoundActionCreator, createType } from '../../../../../shared/state/index.state';
import { SatelliteOtherDetails, SatelliteSurveillance } from '../admin-satellite-surveillance.model';

/**
 * https://medium.com/frontend-fun/angular-ngrx-a-clean-and-clear-introduction-4ed61c89c1fc
 */

@Injectable()
export class SatelliteSurveillanceActions {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              ACTION CREATORS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    static GET_SATELLITE_SURVEILLANCE =
        createActionCreator<number>(createType('[Admin:Satellite:Surveillance] Get Satellite Surveillance'));
    static GET_SATELLITE_SURVEILLANCE_SUCCESS =
        createActionCreator<any>(createType('[Admin:Satellite:Surveillance] Get Satellite Surveillance Success'));
    static GET_SATELLITE_SURVEILLANCE_FAIL =
        createActionCreator<any>(createType('[Admin:Satellite:Surveillance] Get Satellite Surveillance Failed'));

    static GET_SATELLITE_OTHER_DETAILS =
        createActionCreator<SatelliteSurveillance>(createType('[Admin:Satellite:Surveillance] Get Satellite Other Details'));
    static GET_SATELLITE_OTHER_DETAILS_SUCCESS =
        createActionCreator<any>(createType('[Admin:Satellite:Surveillance] Get Satellite Other Details Success'));
    static GET_SATELLITE_OTHER_DETAILS_FAIL =
        createActionCreator<any>(createType('[Admin:Satellite:Surveillance] Get Satellite Other Details Failed'));

    constructor(private store: Store<any>) {
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    //              BOUND ACTIONS
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    getSatelliteSurveillance =
        createBoundActionCreator(SatelliteSurveillanceActions.GET_SATELLITE_SURVEILLANCE, this.store.dispatch.bind(this.store));

    getSatelliteOtherDetails =
        createBoundActionCreator(SatelliteSurveillanceActions.GET_SATELLITE_OTHER_DETAILS, this.store.dispatch.bind(this.store));

}
